import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import CompareArrowsOutlinedIcon from '@mui/icons-material/CompareArrowsOutlined';
import PeopleOutlineOutlinedIcon from '@mui/icons-material/PeopleOutlineOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import { useTokens } from 'theme';
import { toneOf } from './chartParts';

const ICONS = {
  cart: ShoppingCartOutlinedIcon,
  users: PeopleOutlineOutlinedIcon,
  receipt: ReceiptLongOutlinedIcon,
  revenue: BarChartOutlinedIcon,
  diff: CompareArrowsOutlinedIcon,
  wallet: AccountBalanceWalletOutlinedIcon,
};

/** The card's heading, sized from the chart theme like the canvas inside it. */
export function ChartTitle({ id, icon, tone, children }) {
  const { type, tones } = useTokens().chart;
  const Icon = ICONS[icon];
  return <Typography id={id} component="h3" sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0, fontSize: type.title, fontWeight: type.titleWeight, lineHeight: 1.3 }}>
    {Icon && <Icon aria-hidden sx={{ flex: 'none', fontSize: 20, color: toneOf(tones, tone).colour }} />}
    <span>{children}</span>
  </Typography>;
}

/** One frame for every widget state: loading, the chart, a table or its placeholder. */
export default function ChartCard({ title, actions, minHeight, children, ...section }) {
  return <Paper component="section" variant="outlined" {...section} sx={{ p: 2, width: '100%', minWidth: 0, minHeight, boxSizing: 'border-box' }}>
    {(title || actions) && <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: title ? 1.5 : 0 }}>
      {title && <Box sx={{ flex: 1, minWidth: 0 }}>{title}</Box>}
      {actions}
    </Box>}
    {children}
  </Paper>;
}
